// The fields a user's form insists on: what is needed to start (owner,
// 2026-11-04). The same when editing, so a user added this way can be edited;
// the rest can be filled in later.
export const requiredUserFields = () => ["tz", "firstname", "lastname", "phone"];
